import { defineStore } from 'pinia';
import i18n from '@/common/i18n';
import SetupCompanyRepository from '@/repositories/setupCompanyRepository';
import apiResponseErrorService from '@/commonProject/service/apiResponseErrorService';
import cognitoRepository from '@/repositories/common/cognitoRepository';

export const useSetupCompanyStore = defineStore({
    id: 'setupCompany',
    state: () => ({}),
    getters: {},
    actions: {
        /**
         * ユーザーが入力した企業パスワードが正当か判定する処理。
         */
        async checkUserCompanyPasswordAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const setupCompanyRepository = new SetupCompanyRepository();
            try {
                // ユーザー企業PW確認APIをコールする。
                const response = await setupCompanyRepository.checkUserCompanyPasswordActionApi(API_URL, requestBody, idToken);
                // ユーザー企業パスワードの判定処理では、200 OKのレスポンス結果のエラーフラグを一律エラーにせず、画面に返却する。
                /*
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                */
                return { success: true, responseBody: response.data };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'post', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
    },
});
